import { useQuery } from '@tanstack/react-query';

import getV1StockHistorytradefilterById from '@services/api/stock/history/regularDetail';

/**
 * @param {object}  ObjectParams
 * @param {string}  ObjectParams.idxTradeNo   (Ex: "202306140000017210")
 * @param {string}  ObjectParams.startDate    Format: YYYY-MM-DD
 */
function useHistoryRegularDetail({ idxTradeNo, startDate }) {
  const { cb, key } = getV1StockHistorytradefilterById({ idxTradeNo, startDate });

  const { data, isSuccess, isLoading } = useQuery(key, cb, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, isLoading };
}

export default useHistoryRegularDetail;
